import * as React from "react";

function SvgWifi(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 41 33"
      {...props}
    >
      <g
        stroke="currentColor"
        strokeWidth={1.8}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
      >
        <path d="M1.177 9.106c4.893-4.894 11.647-7.93 19.13-7.93 7.481 0 14.234 3.036 19.129 7.93" />
        <path d="M34.447 14.095a19.957 19.957 0 00-14.142-5.86 19.953 19.953 0 00-14.14 5.86m23.295 4.988a12.929 12.929 0 00-9.154-3.788 12.932 12.932 0 00-9.153 3.788m9.153 5.623a3.53 3.53 0 110 7.062 3.53 3.53 0 010-7.063z" />
      </g>
    </svg>
  );
}

export default SvgWifi;
